import { noop } from 'lodash'
import { createStore } from 'zustand'

import { toArray } from '@eastcoal/common/utils/array'
import { pick } from '@eastcoal/common/utils/object'

import { KindRootNodeStore } from './interface'

export const createKindRootNodeStore = <M extends boolean>() =>
  createStore<KindRootNodeStore<M>>((set, get) => ({
    data: [],
    loading: false,
    error: undefined,
    reload: noop,

    multiple: undefined,
    value: undefined,
    onChange: undefined,
    setValue(value) {
      set({
        value,
        selectedKeys: value ? toArray(value).map(item => `${item.id}`) : []
      })
    },

    selectedKeys: [],
    setSelectedKeys(keys) {
      const { multiple, data, onChange } = get()
      const selectedKeys = multiple ? keys : toArray(keys)
      const values = data
        .filter(item => selectedKeys.includes(`${item.id}`))
        .map(item => pick(item, ['id', 'name', 'quotas', 'code']))
      const value: any = multiple ? values : values[0]

      set({
        selectedKeys,
        value
      })

      onChange?.(value)
    }
  }))
